"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerPictureLoader = void 0;
var tslib_1 = require("tslib");
var number_1 = require("@devexpress/utils/lib/utils/map/number");
var load_pictures_info_1 = require("../../../changes/sub-document/picture/load-pictures-info");
var image_cache_info_converter_1 = require("../../../json/importers/image-cache-info-converter");
var picture_loader_1 = require("./picture-loader");
var ServerPictureLoader = (function (_super) {
    tslib_1.__extends(ServerPictureLoader, _super);
    function ServerPictureLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ServerPictureLoader.prototype.loadInner = function (data) {
        var _this = this;
        if (data.imageUrl && (data.imageUrl.match(/^file\:\/\//gi) || data.imageUrl.match(/^blob\:/gi)))
            this.resetCacheImageInfoToDefault(data);
        if (data.file)
            this.loadPictureByFile(data, function (data) { return _this.notifyLoad(data); });
        else if (data.imageUrl || data.base64)
            this.notifyLoad(data);
        return data;
    };
    ServerPictureLoader.prototype.notifyLoad = function (data) {
        this.modelManipulator.notifyModelChanged(new load_pictures_info_1.LoadPicturesInfoSubDocumentChange(this.modelManipulator.model.mainSubDocument.id, data));
    };
    ServerPictureLoader.prototype.applyRequest = function (jsonObjs) {
        var _this = this;
        number_1.NumberMapUtils.forEach(jsonObjs, function (jsonImgInfo) {
            return _this.finalizeLoading(image_cache_info_converter_1.JSONCacheImageInfoConverter.convertFromJSON(jsonImgInfo));
        });
    };
    ServerPictureLoader.prototype.resetCacheImageInfoToDefault = function (data) {
        data.imageUrl = undefined;
        data.base64 = this.imageCache.emptyImage.base64;
    };
    return ServerPictureLoader;
}(picture_loader_1.PictureLoader));
exports.ServerPictureLoader = ServerPictureLoader;
